/**
 * The type of (redux) action to reset the breakout rooms data.
 */
export const _RESET_BREAKOUT_ROOMS = '_RESET_BREAKOUT_ROOMS';
/**
 * The type of (redux) action to update the room counter locally.
 */
export const _UPDATE_ROOM_COUNTER = '_UPDATE_ROOM_COUNTER';
/**
  * The type of (redux) action to update the breakout room data.
  *
  */
export const UPDATE_BREAKOUT_ROOMS = 'UPDATE_BREAKOUT_ROOMS';
/**
* Open Participants Pane Modal.
*/
export const OPEN_BREAKOUT_ROOM_MODAL = "OPEN_BREAKOUT_ROOM_MODAL";
/**
* Close Participants Pane Modal.
*/
export const CLOSE_BREAKOUT_ROOM_MODAL = "CLOSE_BREAKOUT_ROOM_MODAL";
/**
* Close Participants Pane Modal.
*/
export const BREAKOUT_ROOM_MODAL_ID = "breakoutRoomModalView";
/**
 * The type of (redux) action to set the persistent auto-assign setting.
 */
export const SET_PERSISTENT_BREAKOUT_AUTO_ASSIGN = 'SET_PERSISTENT_BREAKOUT_AUTO_ASSIGN';
